// Simple toast event bus and helpers to trigger toasts from anywhere (components or services)

export type ToastVariant = 'success' | 'error' | 'info' | 'warning';

export interface ToastEvent {
	id: string;
	message: string;
	title?: string;
	variant: ToastVariant;
	duration?: number; // ms
}

type ToastListener = (toast: ToastEvent) => void;

const listeners = new Set<ToastListener>();

export function subscribeToToasts(listener: ToastListener): () => void {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

function emit(toast: Omit<ToastEvent, 'id'>) {
	const withId: ToastEvent = {
		id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
		...toast,
	};
	listeners.forEach((l) => l(withId));
}

export function toast(message: string, options?: { title?: string; variant?: ToastVariant; duration?: number }) {
	emit({
		message,
		title: options?.title,
		variant: options?.variant || 'info',
		duration: options?.duration || 3500,
	});
}

export function toastSuccess(message: string, title?: string, duration?: number) {
	toast(message, { title, variant: 'success', duration });
}

export function toastError(message: string, title?: string, duration?: number) {
	toast(message, { title, variant: 'error', duration });
}

export function toastInfo(message: string, title?: string, duration?: number) {
	toast(message, { title, variant: 'info', duration });
}

export function toastWarning(message: string, title?: string, duration?: number) {
	toast(message, { title, variant: 'warning', duration });
}


